export default "__VITE_ASSET__BwQ_L$r9__"